/*import scrollWidth from "../modules/ScrollbarWidth";*/

// Задаем цвета в блоках

// Дефолтный цвет сайта
let defaultColor = App.H.data('color-scheme');
let bulletsColor = App.H.data('bullets-color');

// Если дефолтный цвет не задан, то берем цвет штады
if (!defaultColor) {
    defaultColor = '#025CB9';
}
if (!bulletsColor) {
    bulletsColor = 'rgba(0,93,185,.8)';
}

App.H.css('--default-color', defaultColor);
App.H.css('--bullets-color', bulletsColor);

setElementsColors();

// for ie11
if (App.ie) {
    let elStyleNode = setElementsColors();
    let styleNode = document.createElement("style");
    styleNode.innerText = `html{--default-color: ${defaultColor};} ${elStyleNode}`;
    document.body.appendChild(styleNode);
}

function setElementsColors() {
    let elStyle = '';

    $('[data-colored]').each(function(e) {
        let $currEl = $(this);
        let elBackColor = $currEl.data('back-color');
        let elColor = $currEl.data('color');
        let elBorderColor = $currEl.data('border-color');
        let elIconColor = $currEl.data('icon-color');
        let elHoverIconColor = $currEl.data('hover-icon-color');
        let elTextColor = $currEl.data('text-color');

        /* для баннера, где надо задавать отдельные цвета текста для мобилы и десктопа */
        let elDesktopColor = $currEl.data('desktop-color');
        let elMobileColor = $currEl.data('mobile-color');

        /* для кнопок с градиентным фоном */
        let elBackColorBegin = $currEl.data('back-color-begin');
        let elBackColorEnd = $currEl.data('back-color-end');

        let style = $currEl[0].style.cssText || '';
        if (App.ie) {
            $currEl.addClass('customColor-' + e);
        }

        let pollDefaultColor = $currEl.data('default-color');
        let pollResultColor = $currEl.data('result-color');

        if (elBackColor) {
            style += `--back-color: ${elBackColor};`;

            // Обработка исключения когда --back-color == #ffffff. Конфликт в css/constructor/c-colors.less в классе .button--default-bordered[data-colored]:hover {color: @schemeColor;}
            if ($currEl.hasClass('button--default-bordered') && elBackColor.toLowerCase() != '#ffffff' && elBackColor.toLowerCase() != '#fff') {
                style += `--default-color: #ffffff;`
            }
        }

        if (elColor) {
            style += `--color: ${elColor};`
        }

        if (elBorderColor) {
            style += `--border-color: ${elBorderColor};`
        }

        if (pollDefaultColor) {
            style += `--default-color: ${pollDefaultColor};`
        }

        if (pollResultColor) {
            style += `--result-color: ${pollResultColor};`
        }

        if (elIconColor) {
            style += `--icon-color: ${elIconColor};`
        }

        if (elHoverIconColor) {
            style += `--hover-icon-color: ${elHoverIconColor};`
        }

        if (elBackColorBegin) {
            style += `--back-color-begin: ${elBackColorBegin};`
        }

        if (elBackColorEnd) {
            style += `--back-color-end: ${elBackColorEnd};`
        }

        if (elTextColor) {
            style += `--text-color: ${elTextColor};`
        }


        /* для баннера, гда надо задавать отдельные цвета текста для мобилы и десктопа */
        if (elDesktopColor) {
            style += `--desktop-content-color: ${elDesktopColor};`
        }

        // если мобильный цвет задан, то цепляем его, если нет — цепляем цвет десктопа
        if (elMobileColor) {
            style += `--mobile-content-color: ${elMobileColor};`
        } else if (elDesktopColor) {
            style += `--mobile-content-color: ${elDesktopColor};`
        }

        $currEl[0].style.cssText = style;

        if (App.ie) {
            elStyle += '.customColor-' + e + ' {' + style + '}';
        }
    });

    if (App.ie) {
        return elStyle;
    }
}
